<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col
        router-link.button-previous.mr-2(to="/dialogo-desempeno/id")
          i.fas.fa-chevron-left
        h2.m-0.d-inline-block.align-middle
          i {{$route.name}}
      .col-auto
        //- button.btn.btn__small.btn-secondary.font-italic
        //-   | Exportar
        //-   i.fas.fa-file-download.ml-2
    section
      .d-flex.row.flex-row.align-items-end
        .col
          h3.text-thin 
            i {{detail.description ? detail.description : null}}
      .d-flex.row.flex-row.align-items-end
        .col
        .col-auto.text-right
          p.font-italic.m-0
            span.ad_text-grayLight Fecha ejecución:
            | {{ detail.dateScheduled }} 
            //- | {{ moment(detail.dateScheduled, 'DD/MM/YYYY').utc().format("DD/MM/YYYY") }}
      .d-flex.row.flex-row.mt-4
        .col-7
          .card.ad_border1-secondaryLight.rounded-xl
            h4.ad_text-primary
              i Objetivos
            .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in detail.objectives")
              form
                .d-flex.row.form-group.align-items-end
                  .col
                    label(:id="'objectives-' + index")
                      i.icon-letters.icon-letters__viaje.mr-1 V
                      i.icon-letters.icon-letters__producto.mx-1 P
                      i.icon-letters.icon-letters__segmento S
                    b-tooltip(:target="'objectives-' + index", placement='top')
                      | {{ `${objective.travel.name} + ${objective.product.name} + ${objective.segmentName}`}}
                      
                    label.ml-1(:id="'objective-A-' + index")
                      i.icon-letters.icon-letters__negocio.mr-1 N
                    b-tooltip(:target="'objective-A-' + index", placement='top')
                      | {{objective.business_type.name}}
                  .col-auto
                    p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                      sup Registro
                      span {{objective.businesspercentage}}%
                    p.d-inline-block.mb-0.ad_text-grayMedio
                      sup Meta
                      span {{objective.goalKpi}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th 
                        th Registro
                        th Meta
                        //- th
                    tbody
                      tr
                        td
                          div.pr-0
                            span.num_circle.ad_bg-secondary {{index + 1}}
                        td.text-left
                          div
                            | {{objective.kpi.name}}
                        td
                          div
                            span.ad_text-success
                              //- TODO: se debe confirmar que esto este ok.
                              //- | {{objective.plan.name}}
                              //- | {{objective.date | WeekDuration}}&deg; sem
                        td
                          div.justify-content-center
                            | {{objective.kpipercentage}}%
                        td
                          div.justify-content-center
                            | {{objective.goalKpi}}%
                        //- td(width="40")
                        //-   div
                        //-     a.no-decoration(href="#" title="Comentarios")
                        //-       i.icono.icono-comentarios.ad_text-primary
        .col-5
          .card.ad_border1-secondaryLight.rounded-xl
            h4.ad_text-primary
              i Asistentes
            .row.m-0
              .col-12.py-3.ad_bg-gray.rounded-xl
                p.mb-1(v-for="assistant in detail.assistants") {{assistant}}
              .col-12
                p.mt-3.mb-0
                  i.ad_text-success Asistentes {{assistant}}


        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Compromisos equipo 
              
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  h4.ad_text-secondary
                    i Previos
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Responsable/es
                        th Descripción
                        th Objetivo
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        //- th
                    tbody
                      tr(v-for="pendingCommitment in detail.pendingCommitments")
                        td(width="20%")
                          div
                            | {{ pendingCommitment | Responsibles(pendingCommitment) }}
                        td
                          div.py-2
                            | {{pendingCommitment ? pendingCommitment.description : ''}}
                        td
                          div
                            i.icono.icono-objetivos.align-top.ad_text-primary.mr-2
                            | {{pendingCommitment.objective.kpi ? pendingCommitment.objective.kpi : ''}}
                        td
                          div
                            | {{moment(pendingCommitment.date).format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pendingCommitment.scheduled).format("DD/MM/YYYY")}}
                        //- td.text-right(width="40")
                        //-   div
                        //-     a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                        //-       i.icono.icono-comentarios.ad_text-primary
              .row.mt-4
                .col
                  h4.ad_text-success
                    i Creados
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Responsable/es
                        th Descripción
                        th Objetivo
                        th Fecha de Compromiso
                        //- th
                    tbody
                      tr(v-for="newCommitment in detail.newCommitments")
                        td
                          div
                            | {{ newCommitment | Responsibles(newCommitment) }}
                        td
                          div
                            | {{newCommitment ? newCommitment.description : null }}
                        td
                          div
                            i.icono.icono-objetivos.align-top.ad_text-primary.mr-2
                            | {{newCommitment.objective.kpi ? newCommitment.objective.kpi : ''}}
                        td
                          div
                            | {{moment(newCommitment.scheduled).format("DD/MM/YYYY")}}
                        //- td.text-right(width="40")
                        //-   div
                        //-     a.no-decoration.text-thin(href="#" title="Comentarios" @click.stop='drawerCompromiso = !drawerCompromiso')
                        //-       i.icono.icono-comentarios.ad_text-primary

        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Problemas & Oportunidades 
              
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  h4.ad_text-secondary
                    i Previos
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Observador
                        th Descripción
                        th Responsable
                        th Fecha de ingreso
                        //- th
                    tbody
                      tr(v-for="pendingProblem in detail.pendingProblems")
                        td
                          div
                            | {{pendingProblem.observer ? pendingProblem.observer.name : null }}
                        td
                          div
                            | {{pendingProblem ? pendingProblem.description : null }}
                        td
                          div
                            | {{pendingProblem.responsible ? pendingProblem.responsible.name : null}}
                        td
                          div
                            | {{moment(pendingProblem.creation_date).format("DD/MM/YYYY")}}
                        //- td.text-right(width="40")
                        //-   div
                        //-     a.no-decoration(href="#" title="Comentarios" @click.stop='drawerProblemasComentarios = !drawerProblemasComentarios; nameSection(data)')
                        //-       i.icono.icono-comentarios.ad_text-primary
              .row.mt-4
                .col
                  h4.ad_text-success
                    i Creados
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Observador
                        th Descripción
                        th Responsable
                        //- th
                    tbody
                      tr(v-for="newProblem in detail.newProblems")
                        td
                          div
                            | {{newProblem.observer ? newProblem.observer.name : null}}
                        td
                          div
                            | {{ newProblem ? newProblem.description : null }}
                        td
                          div
                            | {{newProblem.responsible ? newProblem.responsible.name : null}}
                        //- td.text-right(width="40")
                        //-   div
                        //-     a.no-decoration(href="#" title="Comentarios")
                        //-       i.icono.icono-comentarios.ad_text-primary

        .col-12
          .card.ad_border1-secondaryLight.rounded-xl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-top.py-2
              .col
                h4.m-0.ad_text-primary
                  i Otros temas 

          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.w-100.text-left.table-rounded-body
                    thead
                      tr
                        th Asunto
                        th Descripción
                    tbody
                      tr(v-for="theme in detail.themes")
                        td
                          div
                            | {{theme.issue}}
                        td
                          div
                            | {{theme ? theme.description : null}}

            
    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Cerrar {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-7
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Objetivo
              span.ad_text-grayDark 
                i.far.fa-square
                |  Viaje
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup 
              span.ad_text-grayDark 
                i.far.fa-square
                |  KPI de Negocio1 KPI Adherencia
        .row.mx-0.align-items-end
          .col-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de compromiso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-5
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
    
    v-navigation-drawer(v-model='drawerCompromiso', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col.mb-3
          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
            sup Responsable
            span.ad_text-grayDark Jefatura
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Objetivo
              span.ad_text-grayDark 
                i.far.fa-square
                |  Viaje
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup 
              span.ad_text-grayDark 
                i.far.fa-square
                |  KPI de Negocio1 KPI Adherencia
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawerCompromiso = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="drawerCompromiso = false")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.

    v-navigation-drawer(v-model='drawerProblemasComentarios', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentario {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Observador
              span.ad_text-grayDark Francisco G
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
    
    v-navigation-drawer(v-model='drawerProblemasCerrar', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Cerrar {{data}}
      section.py-4.px-2.overflowy-auto
        .row.mx-0.align-items-start
          .col-7
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Responsable
              span.ad_text-grayDark Jefatura
          .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
        .row.mx-0.align-items-start
          .col-12.mb-3
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Observador
              span.ad_text-grayDark Francisco G
        .row.mx-0.mb-3.align-items-end
          .col-12
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Descripción
              span.ad_text-grayDark Descripción del compromiso obtenido 
        .row.mx-0.align-items-end
          .col
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Fecha de ingreso
              span.ad_text-grayDark 
                | 02-01-2019 
                span.ad_text-danger.font-italic  2&deg; sem
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.

</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {

  name: 'DialogoDesempenoDetail',
  components: {
  },
  data () {
    return {
      detail: {
        dateExecution: "",
        dateScheduled: "",
        description: "",
        newCommitments: [],
        newProblems: [],
        objectives: [],
        pendingCommitments: [],
        pendingProblems: [],
        themes: [],
      },
      menu: false,
      date: null, 
      compromiso: true,
      problemas: true,
      otros: true,
      lorem: '',
      value: { value: '', label: '' },
      responsable: '',
      responsables: [],
      observador: '',
      observadores: [],
      objetivo: '',
      objetivos: [],
      drawer: null,
      drawerCompromiso: null,
      drawerProblemasComentarios: null,
      drawerProblemasCerrar: null,
      cumplimiento: null,
      data: null,
      assistant: ''
    }
  },
  methods: {
    moment,
    ...mapActions('meeting', ['getMeetingDetailByMeetingAndUserId']),
    nameSection: function(data){
      this.data = 'Problema & Oportunidad'
    },
    nameCompromiso: function(data){
      this.data = 'Compromiso'
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle de DDD...')
      vm.user = vm.$store.getters['auth/getUserInfo']; 
      vm.getMeetingDetailByMeetingAndUserId({meetingId: id, userId: vm.user.id}).then(response => {
          vm.detail = response
          loading.hide()
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
    },
  },
  watch: {
    moveobjetivo: function(){
      let moveobjetivo = this.moveobjetivo
      if(this.moveobjetivo === true) {
          this.$emit('can-continue', {value: true});
          this.$emit('completed-step', {value: true});
      } else {
          this.$emit('can-continue', {value: false});
      }
    },
    drawer : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
    drawerCompromiso : function() {
      this.$parent.overlay = !this.$parent.overlay
      this.$emit('clase', this.$parent.overlay)
      const el = document.querySelector('.overlay')

      if (this.$parent.overlay) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
    },
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id);
    this.$emit('can-continue', { value: true });
  }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/dialogo-desempeno-detail.vue